// Single source of truth for the LLM providers MyAgent supports.
// Consumed by the worker (RPC allowlist) and the UI (editor dropdown)
// so the two can't drift. To add a provider: append here + implement the
// adapter in llm-sdk.

export interface SupportedProvider {
  id: string
  displayName: string
  models: readonly string[]
  defaultModel: string
}

export const SUPPORTED_PROVIDERS: readonly SupportedProvider[] = [
  {
    id: 'openai',
    displayName: 'OpenAI',
    models: ['gpt-5.5', 'gpt-5.4', 'gpt-5.4-mini', 'gpt-5-mini', 'gpt-4.1', 'o3'],
    defaultModel: 'gpt-5-mini',
  },
  {
    id: 'gemini',
    displayName: 'Google Gemini',
    models: [
      'gemini-3.1-pro-preview',
      'gemini-3-flash-preview',
      'gemini-3.1-flash-lite-preview',
      'gemini-2.5-pro',
      'gemini-2.5-flash',
    ],
    defaultModel: 'gemini-2.5-flash',
  },
] as const

export const SUPPORTED_PROVIDER_IDS: readonly string[] = SUPPORTED_PROVIDERS.map(p => p.id)

export const isSupportedProvider = (id: string): boolean => SUPPORTED_PROVIDER_IDS.includes(id)
